import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import useFetch from '../../hooks/useFetch'
import { SEOPageNames } from '../../Contansts'

function Head() {
  const { pathname } = useLocation()

  const {
    loading,
    data: seoData,
    error,
  } = useFetch('seo', null, `pagename=${SEOPageNames[pathname]}`)

  if (loading || error) return null
  const data = seoData.length > 0 ? seoData[0] : {}
  const seocontent = data?.seocontent.length > 0 ? data?.seocontent[0] : {}
  let {
    enable_indexing: enableIndexing = true,
    // page_name,
    seo_canonical_link: pageLink,
    seo_description: desc,
    seo_keywords: keyword,
    seo_title: title,
  } = seocontent || {}
  enableIndexing = enableIndexing ?? true

  return (
    <Helmet>
      {!enableIndexing ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      {/** if indexing not required for a page then this above line will be added which stops the google search engine for indexing */}
      <meta name="title" content={title || ''} />
      <meta name="description" content={desc || ''} />
      <meta name="keywords" content={keyword || ''} />
      <title>{title}</title>
      <link rel="canonical" href={pageLink || ''} />

      {/*  Open Graph Tags */}
      <meta property="og:title" content={title || ''} />
      <meta property="og:description" content={desc || ''} />
      {/* <meta property="og:image" content="https://www.example.com/image.jpg" /> */}
      <meta property="og:url" content={pageLink || ''} />
    </Helmet>
  )
}

export default Head
